import { render, staticRenderFns } from "./add-organization.vue?vue&type=template&id=5aa98aff&scoped=true"
import script from "./add-organization.vue?vue&type=script&lang=js"
export * from "./add-organization.vue?vue&type=script&lang=js"
import style0 from "./add-organization.vue?vue&type=style&index=0&id=5aa98aff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa98aff",
  null
  
)

export default component.exports